import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next';

const MembershipSuccessModal = ({setOpenMembershipPaymentDetails}: {setOpenMembershipPaymentDetails: Dispatch<SetStateAction<boolean>>}) => {
    const {t} = useTranslation();
  return (
    <div className='p-5 overflow-y-auto min-h-[400px] flex flex-col gap-10 items-center justify-center max-h-[80vh]'>
        <img width={100} src="/images/bookingConfirmation.png" alt="check"/>
        <p className='text-xl font-bold text-center whitespace-pre-line'>{t("membershipPurchasedSuccessfully")}</p>
        <div className='flex justify-center items-center my-4'>
        <button onClick={()=>setOpenMembershipPaymentDetails(false)} className='rounded-full bg-secondary px-4 py-2 text-white hover:text-secondary hover:bg-primary min-w-[250px]'>{t("okay")}</button>
        </div>
        </div>
  )
}

export default MembershipSuccessModal